export default __webpack_public_path__ + "static/right-tree-9d5339a871bb29a62feae5d8e1619b44.png";